// ============================================================
//  SUPPORT API — ADMIN DASHBOARD
//  Path: src/api/support.api.ts
//
//  NEW FILE. Backend base path: /api/admin/support (admin.routes.js)
// ============================================================

import api from '../config/api'

export type SupportStatus = 'open' | 'answered' | 'closed'

export interface SupportRequestRow {
  id: string
  userId: string
  userName: string | null
  appType: 'expert' | 'customer'
  topic: string
  message: string
  screenName: string | null
  pageHeading: string | null
  appVersion: string | null
  platform: string | null
  contactEmail: string | null
  contactPhone: string | null
  status: SupportStatus
  adminNote: string | null
  handledAt: string | null
  emailSent: boolean
  createdAt: string
}

export interface SupportOptions {
  actionScreens: { expert: Record<string, string>; customer: Record<string, string> }
  topics: string[]
}

export const listSupportRequestsApi = (params: { status?: string; appType?: string; search?: string; page?: number; limit?: number }) =>
  api.get('/api/admin/support/requests', { params })

export const updateSupportRequestApi = (id: string, body: { status?: SupportStatus; adminNote?: string | null }) =>
  api.patch(`/api/admin/support/requests/${encodeURIComponent(id)}`, body)

export const sendSupportMessageApi = (body: {
  userId?: string; email?: string; appType?: 'expert' | 'customer'; title: string; body: string; actionScreen?: string; requestId?: string
}) => api.post('/api/admin/support/messages', body)

// Open (not yet answered) help requests: overall count + per person.
export interface SupportOpenSummary {
  openCount: number
  byUser: Record<string, { expert: number; customer: number; total: number }>
}
export const getSupportOpenSummaryApi = (userIds?: string[]) =>
  api.get('/api/admin/support/requests/summary', { params: userIds && userIds.length ? { userIds: userIds.join(',') } : {} })

// Fired by SupportPage after every load and change, so the menu badge
// updates at once instead of waiting for its next check.
export const SUPPORT_OPEN_COUNT_EVENT = 'support:open-count'
export const announceSupportOpenCount = (count: number) => {
  try { window.dispatchEvent(new CustomEvent(SUPPORT_OPEN_COUNT_EVENT, { detail: { count } })) } catch { /* old browser */ }
}

export const getSupportOptionsApi = () => api.get('/api/admin/support/options')

export const listSupportMessagesForUserApi = (userId: string) =>
  api.get(`/api/admin/support/users/${encodeURIComponent(userId)}/messages`)